import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';

const About = ({ show, onHide }) => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const currentVersion = '1.0.0'; // This should match your package.json version
  
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>ℹ️ About Taxi-Local</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-4">
          <h4 className="text-warning">Taxi-Local.uk</h4>
          <p className="text-muted">Connecting Professional Drivers with Local Communities</p>
        </div>
        
        <div className="mb-4">
          <h5>About Taxi-Local</h5>
          <p>
            Taxi-Local is a comprehensive platform designed to connect professional taxi drivers 
            with local communities across the UK. Our mission is to provide reliable, efficient, 
            and community-focused transportation services while supporting drivers with modern 
            tools and technology.
          </p>
          
          <p>
            The platform offers a complete solution for job management, scheduling, payment 
            processing, and customer communication, making it easier for drivers to focus on 
            what they do best - providing excellent service to their customers.
          </p>
        </div>
        
        <div className="mb-4">
          <h5>Key Features</h5>
          <ul>
            <li>Real-time job monitoring and notifications</li>
            <li>Integrated payment processing with multiple payment methods</li>
            <li>Comprehensive diary and scheduling management</li>
            <li>Customer relationship management tools</li>
            <li>Professional driver dashboard and statistics</li>
            <li>Secure and reliable platform infrastructure</li>
          </ul>
        </div>
        
        <div className="mb-4">
          <h5>Technology</h5>
          <p>
            Built with modern web technologies including React, Node.js, and MongoDB, 
            Taxi-Local provides a responsive and user-friendly experience across all devices.
          </p>
        </div>
        
        <div className="row">
          <div className="col-md-6">
            <h5>Version Information</h5>
            <p><strong>Current Version:</strong> {currentVersion}</p>
            <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-GB')}</p>
          </div>
          <div className="col-md-6">
            <h5>Support</h5>
            <p>
              For technical support or questions about the platform, please use the 
              Troubleshooting section in your dashboard or contact our support team.
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="text-center w-100">
          <p className="text-muted mb-2">
            © {new Date().getFullYear()} Taxi-Local.uk. All rights reserved.
          </p>
          <p className="text-muted small mb-2">
            Taxi-Local is a registered service providing professional transportation solutions across the United Kingdom.
          </p>
          <p className="text-muted small mb-0">
            <button
              type="button"
              className="btn btn-link text-decoration-none p-0 align-baseline"
              onClick={() => setShowTerms(true)}
            >
              Terms &amp; Conditions
            </button>{' '}
            |{' '}
            <button
              type="button"
              className="btn btn-link text-decoration-none p-0 ms-2 align-baseline"
              onClick={() => setShowPrivacy(true)}
            >
              Privacy Policy
            </button>{' '}
            |{' '}
            <Link to="/cookies-policy" className="text-decoration-none ms-2" onClick={onHide}>
              Cookie Policy
            </Link>
          </p>
        </div>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
      
      {/* Terms and Conditions Modal */}
      <TermsAndConditions show={showTerms} onHide={() => setShowTerms(false)} />
      {/* Privacy Policy Modal */}
      <PrivacyPolicy show={showPrivacy} onHide={() => setShowPrivacy(false)} />
    </Modal>
  );
};

export default About;
